<div class="container">
    <div class="top">
        <div class="employee-name">
            <app-employee-image [profilePhoto]="review.reviewedBy?.profilePhoto" [width]="35" [height]="35" [round]="true" aria-hidden="true"></app-employee-image>

            <span class="employee">
                {{review.reviewedBy?.firstName}} {{review.reviewedBy?.lastName}}
            </span>
        </div>

        <div *ngIf="user$.userId === review.reviewedBy?.id">
            <button class="settings-button" mat-mini-fab [matMenuTriggerFor]="settings" appPreventDoubleClick (throttledClick)="$event.stopPropagation()" [attr.aria-label]="('Settings' | translate: {Default: 'Settings'}) + ' ' + review.reviewedBy?.firstName + ' ' + review.reviewedBy?.lastName">
                <mat-icon class="settings-button__icon material-icons-outlined" aria-hidden="true">more_vert</mat-icon>
            </button>
            <div class="settings-menu">
                <mat-menu #settings="matMenu" xPosition="before">
                    <button class="settings-menu__item material-icons-outlined" appPreventDoubleClick (throttledClick)="showForm = true" mat-menu-item>
                        <mat-icon class="settings-button__icon material-icons-outlined" aria-hidden="true">edit</mat-icon>
                        {{ 'Edit' | translate: {Default: "Edit"} }}
                    </button>
                    <!-- <button class="settings-menu__item material-icons-outlined" appPreventDoubleClick (throttledClick)="deleteRating();" mat-menu-item>
                        <mat-icon class="settings-button__icon material-icons-outlined">delete</mat-icon>
                        {{ 'Delete' | translate: {Default: "Delete"} }}
                    </button> -->
                </mat-menu>
            </div>
        </div>
    </div>

    <div *ngIf="user$.userId === review.reviewedBy?.id && showForm; else showDetails">

        <form *ngIf="reviewRatingForm" [formGroup]="reviewRatingForm">
            <mat-form-field appearance="fill" *ngIf="reviewerPermissions?.overallRating !== 'None'">
              <mat-label>{{ 'Review-Rating' | translate: {Default: 'Rating'} }}</mat-label>
              <mat-select disableOptionCentering formControlName="rating">
                <mat-option></mat-option>
                <mat-option *ngFor="let rating of reviewRatingOptions" [value]="rating.rating?.id">
                  {{rating.rating?.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="review-comments" *ngIf="reviewerPermissions?.overallComments !== 'None'">
              <mat-label>{{ 'Review-Comments' | translate: {Default: 'Comments'} }}</mat-label>
              <textarea 
                matInput 
                cdkTextareaAutosize
                maxlength="2000"
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="25"
                cdkAutosizeMaxRows="50"
                formControlName="comments">
              </textarea>
            </mat-form-field>

            <div class="buttons-container">
                <button
                    mat-raised-button
                    appPreventDoubleClick
                    (throttledClick)="showForm = false"
                >{{ 'Cancel' | translate: {Default: "Cancel"} }}</button>

                <button
                    mat-raised-button
                    color="primary"
                    setColor="primaryColour"
                    appPreventDoubleClick
                    (throttledClick)="save()"
                    [disabled]="!reviewRatingForm.valid"
                >{{ 'Save' | translate: {Default: "Save"} }}</button>
            </div>
        </form>
    </div>
    <ng-template #showDetails>
        <ng-container *ngIf="review?.rating === null && review?.comments === null; else showReview">
            <div>{{ 'NoReview' | translate: {Default: "No Review"} }}</div>
        </ng-container>
        <ng-template #showReview>
            <dl>
                <div *ngIf="this.reviewerPermissions?.rating !== 'None'">
                    <dt class="label">{{ 'Rating' | translate: {Default: "Rating"} }}</dt>
                    <dd class="value">{{review.rating.name}}</dd>
                </div>
                <div *ngIf="this.reviewerPermissions?.comments !== 'None'">
                    <dt class="label">{{ 'Comments' | translate: {Default: "Comments"} }}</dt>
                    <dd class="value">{{review?.comments}}</dd>
                </div>
            </dl>
        </ng-template>
    </ng-template>
</div>
